// src/config/virtualLocations.ts
import type { OrgLocation } from "../config/locations";

// Keep ONLY things that are not in the Google Sheet.
export const VIRTUAL_LOCATIONS: OrgLocation[] = [
  {
    id: "virtual_dev_office",
    city: "Dev",
    state: "SC",
    fullName: "Dev Office",
    address: "120 Pinnacle Pl, Suite A, Little River, SC 29566",
    phone: "864-516-6252",
    aliases: ["Dev", "Development", "Developer", "Dev Office"],
  },
  {
    id: "marketing_office",
    city: "Marketing",
    state: "SC",
    fullName: "Marketing Office",
    address: "3145 Magnolia St, Orangeburg, SC 29115",
    phone: "828-291-4347",
    aliases: ["Marketing", "Ads", "Advertising", "Marketing Office", "Ad Office"],
  },
];